export default __webpack_public_path__ + "static/media/apo_hza.8a33475d.png";